<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="充值" left-arrow @click-left="$router.go(-1)" right-text="充值记录"
        @click-right='$router.push({path:"rechargeList"})' />
    </van-sticky>
    <van-cell-group>
      <van-cell title="币种名称" :value="config.name" />
      <van-cell title="充值基数" :value="config.cardinal_number" />
      <van-cell title="充值最小值" :value="config.min" />
      <van-cell title="充值最大值" :value="config.max" />
      <van-cell title="充值方式" :value='typeName' @click='typeShow=true' class='typeOption' is-link arrow-direction='down'>
      </van-cell>
      <div v-if='gatherInfo.type==2'>
        <van-cell title="支付宝昵称" :value="gather.ali_name" />
        <van-cell title="支付宝账号" :value="gather.ali_number" />
        <van-cell title="支付宝收款码">
          <div slot='default'>
            <img :src="gather.ali_image" alt="" style="width:120px;height:120px">
          </div>
        </van-cell>
      </div>
      <div v-if='gatherInfo.type==3'>
        <van-cell title="微信昵称" :value="gather.wx_name" />
        <van-cell title="微信账号" :value="gather.wx_number" />
        <van-cell title="微信收款码">
          <div slot='default'>
            <img :src="gather.wx_image" alt="" style="width:120px;height:120px">
          </div>
        </van-cell>
      </div>
      <div v-if='gatherInfo.type==1'>
        <van-cell title="开户银行" :value="gather.bank_name" />
        <van-cell title="开户支行" :value="gather.bank_branch" />
        <van-cell title="开户人" :value="gather.bank_owner" />
        <van-cell title="银行卡号" :value="gather.bank_number" />
      </div>
    </van-cell-group>
    <van-cell-group>
      <van-field v-model="gatherInfo.money" label="充值金额" placeholder="请输入充值金额" input-align='right' />
      <van-cell title="付款凭证">
        <div slot="default">
          <van-uploader :after-read="upAli">
            <img :src="gatherInfo.pay_image" alt v-if="gatherInfo.pay_image!=''" class="aliImg" />
            <img src="../../assets/imgs/personal/upImg.png" alt class="aliImg" v-else />
          </van-uploader>
        </div>
      </van-cell>
    </van-cell-group>
    <van-action-sheet v-model="typeShow" :actions="options" @select="onSelect" />
    <van-button class="submitBtn" @click="submitGather">提交</van-button>
  </div>
</template>
<script>
  import { userInfo, gathering, updatePayInfo, fileUpload, configRemit, remittanceCommit } from "@/api/personal";
  export default {
    data() {
      return {
        active: 0,
        gatherInfo: {
          type: "1",
          money: '',
          pay_image: "",
          remittance_id: ""
        },
        gather: {},
        typeName: '银行卡',
        config: {},
        typeShow: false,
        options: [{
          name: "银行卡",
          type: 1
        },
        {
          name: "支付宝",
          type: 2
        },
        {
          name: "微信",
          type: 3
        },

        ],
      };
    },
    created() {
      configRemit().then(res => {
        this.config = res;
        this.gatherInfo.remittance_id = res.id;
      })
      gathering().then(res => {
        this.gather = res;
      })
    },
    methods: {
      onSelect(item) {
        this.typeShow = false;
        this.typeName = item.name;
        this.gatherInfo.type = item.type;
      },
      upAli(file) {
        let formData = new FormData();
        formData.append("image", file.file);
        fileUpload(formData).then(res => {
          this.gatherInfo.pay_image = res.path;
        });
      },
      submitGather() {
        if (this.gatherInfo.pay_image == '') {
          this.$toast('请先上传付款凭证!');
          return false;
        }
        remittanceCommit(this.gatherInfo).then(res => {
          this.$toast("提交成功!");
          setTimeout(() => {
            this.$router.go(-1);
          }, 200);
        });
      }
    }
  };
</script>
<style lang='less' scoped>
  .typeOption{
    .van-cell__value{
      color:#3B6BFB;
    }
  }
  .wrap {
    height: 100vh;
    position: relative;
    /deep/ .van-tabs__line {
      background-color: #fe881e;
      height: 0.05rem;
      bottom: 0.5rem;
    }

    .submitBtn {
      position: fixed;
      width: 100%;
      height: 40px;
      color: #fff;
      font-size: 16px;
      background: #3B6BFB;
      left: 0;
      bottom: 0;
      line-height: 40px;
    }

    .aliImg {
      width: 120px;
      height: 120px;
    }
  }
</style>